import { Typography, styled } from '@mui/material';

export const TopBarStyled = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: theme.palette.white.main,
  justifyContent: 'space-between',
  padding: theme.spacing(0, 2),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const TitleCountStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_3,
}));
